import cn from 'classnames'
import { Typography } from '@grammarly/badger-ui'
import { LogoLogomarkColorDefaultIcon } from '@grammarly/design-system'

import styles from './helper-message.module.scss'
import { AlreadyHaveAnAccountLink, SignUpButton } from './ctas'
import { getTextColor } from '@components/page-section/theme'
import { Themes } from 'src/contexts/section-theme-context'

const { TXL, TM } = Typography

interface HelperMessageProps {
  ctaScaleUp?: boolean
  hasSeenWall: boolean
  isForPlagiarismPlanPage: boolean
}

export const HelperMessage = (props: HelperMessageProps) => {
  const { ctaScaleUp, hasSeenWall, isForPlagiarismPlanPage } = props
  const placement = hasSeenWall ? 'wallSide' : 'initialSide'

  return (
    <div className={cn(styles.helperMessageContainer, getTextColor(Themes.Light))}>
      <div className={styles.topSection}>
        <div className={styles.header}>
          <div className={styles.logoContainer}>
            <LogoLogomarkColorDefaultIcon
              aria-label="Grammarly Logo"
              style={{ height: '30px', width: '30px' }}
              aria-hidden={true}
            />
          </div>
          <TXL as="h2">
            <b>{`Let's get started.`}</b>
          </TXL>
        </div>
        <TM as="div" className={styles.instructions}>
          <p>
            <b>Step 1:</b> Add your text or upload a file.
          </p>
          <p>
            <b>Step 2:</b> Click to scan for plagiarism.
          </p>
          <p>
            <b>Step 3:</b> Review the results for instances of potential plagiarism, plus additional writing issues.
          </p>
        </TM>
      </div>
      <div className={styles.ctaContainer}>
        <SignUpButton scaleUp={ctaScaleUp} placement={placement} isForPlagiarismPlanPage={isForPlagiarismPlanPage} />
        <AlreadyHaveAnAccountLink placement={placement} />
      </div>
    </div>
  )
}
